import { createHttpAction } from '@securitize/ui-components';
import { GET_OPPORTUNITY_DEPOSIT_ADDRESSES } from './actionTypes';

export const getOpportunityDepositAddresses = (opportunityId) => {
  const next = GET_OPPORTUNITY_DEPOSIT_ADDRESSES(opportunityId);
  return createHttpAction(next).action;
};
